const jsonParse = (val = '') => {
  try {
    val = JSON.parse(val)
  } catch (e) {
    val = ''
    console.error(e.message)
  }
  return val
}

const jsonStringify = (val = '') => {
  try {
    val = JSON.stringify(val)
  } catch (e) {
    val = ''
    console.error(e.message)
  }
  return val
}

const sessionStorage = {
  get (key) {
    key = '' + key
    if (window.sessionStorage) {
      return jsonParse(window.sessionStorage.getItem(key)) || ''
    } else {
      window.sessionStorage = window.sessionStorage || {}
      return window.sessionStorage.key || ''
    }
  },
  set (key, val) {
    key = '' + key
    if (window.sessionStorage) {
      window.sessionStorage.setItem(key, jsonStringify(val))
    } else {
      window.sessionStorage = window.sessionStorage || {}
      window.sessionStorage.key = val
    }
  },
  clear () {
    if (window.sessionStorage) {
      window.sessionStorage.clear()
    } else {
      window.sessionStorage = {}
    }
  },
  remove (key) {
    key = '' + key
    if (window.sessionStorage) {
      window.sessionStorage.removeItem(key)
    } else {
      window.sessionStorage = window.sessionStorage || {}
      window.sessionStorage.key = ''
    }
  }
}

const localStorage = {
  get (key) {
    key = '' + key
    if (window.localStorage) {
      return jsonParse(window.localStorage.getItem(key)) || ''
    } else {
      window.storage = window.storage || {}
      return window.storage.key || ''
    }
  },
  set (key, val) {
    key = '' + key
    if (window.localStorage) {
      window.localStorage.setItem(key, jsonStringify(val))
    } else {
      window.storage = window.storage || {}
      window.storage.key = val
    }
  },
  clear () {
    if (window.localStorage) {
      window.localStorage.clear()
    } else {
      window.storage = {}
    }
  },
  remove (key) {
    key = '' + key
    if (window.localStorage) {
      window.localStorage.removeItem(key)
    } else {
      window.storage = window.storage || {}
      window.storage.key = ''
    }
  }
}

export default localStorage

/**
 * 此文件暴露两个 storage 的存储方法，这里不再赘述
 */
export {
  sessionStorage,
  localStorage
}


